import { render, staticRenderFns } from "./task-list.vue?vue&type=template&id=3182589b&"
import script from "./task-list.vue?vue&type=script&lang=js&"
export * from "./task-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\xampp\\htdocs\\app.poojalab.com\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3182589b')) {
      api.createRecord('3182589b', component.options)
    } else {
      api.reload('3182589b', component.options)
    }
    module.hot.accept("./task-list.vue?vue&type=template&id=3182589b&", function () {
      api.rerender('3182589b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/task/task-list.vue"
export default component.exports